export enum CreditApplicationType {
    INDIVIDUAL = 'Individual',
    JOINT = 'Joint',
    COAPP = 'CoApplication',
    BUSINESS = 'Business',
    BUSINESS_COAPP = 'BusinessCoApplicant',
    BUSINESS_PG = 'BusinessPersonalGuarantor',
}

export enum RelationshipType {
    NONE = 'None',
    AUNT = 'Aunt',
    BOYFRIEND = 'Boyfriend',
    BROTHER = 'Brother',
    FRIEND = 'Friend',
    GRANDFATHER = 'Grandfather',
    GIRLFRIEND = 'Girlfriend',
    GRANDMOTHER = 'Grandmother',
    OWNER = 'Owner',
    PRESIDENT = 'President',
    SISTER = 'Sister',
    TREASURER = 'Treasurer',
    UNCLE = 'Uncle',
    VICE_PRESIDENT = 'VicePresident',
    PARENT = 'Parent',
    SPOUSE = 'Spouse',
    OTHER = 'Other',
}

export enum VehicleType {
    NEW = 'New',
    PRE_OWNED = 'PreOwned',
    CPO = 'CPO',
    DEMO = 'Demo',
}

export enum SourceSystem {
    DMS = 'DMS',
    FSPortal = 'FSPortal',
    // End of Lease (Remarketing)
    EOL = 'EOL',
    LEGACY = 'LEGACY',
    // Cosumner Submitted Credit Application
    ONLINE = 'ONLINE',
    // Dealer Re-Submiting Consumer Credit Application
    ONLINEDE = 'ONLINEDE',
    // EOL will be replaced by this for submitting credit application for remarketing.
    CompOne = 'CompOne',
    // Auto gravity
    AG = 'AG',
    // Auto gravity online
    AGDE = 'AGDE',
    DEALERTRACK = 'DEALERTRACK',
    // The DealerTrack database
    DTDE = 'DTDE',
    ONLINECA = 'ONLINECA',
    // The onlineca de
    ONLINECADE = 'ONLINECADE',
    // The DMS online resubmitted from DMS systems for US Online apps.
    DMS_ONLINE = 'DMS_ONLINE',
    // The DMS online resubmitted from DMS systems for AG apps.
    DMS_AG = 'DMS_AG',
    // The DMS online resubmitted from DMS systems for Dealer.com apps.
    DMS_DT = 'DMS_DT',
    // The DMS online resubmitted from DMS systems for Canada online apps.
    DMS_ONLCA = 'DMS_ONLCA',
    // My Next Audi Submitted credit application from Oxlo.
    MNA = 'MNA',
    // My Next Audi Resubmit credit application from DE.
    MNADE = 'MNADE',
    // The DMS online resubmitted from DMS systems for My Next Audi apps.
    DMS_MNA = 'DMS_MNA',
    // Consumer Submitted Credit Application
    OFA = 'OFA',
    OFADE = 'OFADE',
    // Consumer resubmitted Credit Application from DE when it was originally submitted by Darwin
    DARWINDE = 'DARWINDE',
    // Consumer Submitted Credit Application
    DARWIN = 'DARWIN',
    // Consumer resubmitted Credit Application from DE when it was originally submitted by Darwin
    DMS_DARWIN = 'DMS_DARWIN',
    // Digital Retail Submitted Credit Application
    DIGITALRETAIL = 'DIGITALRETAIL',
    // Consumer resubmitted Credit Application from DE when it was originally submitted by DIGITALRETAIL
    DMS_DIGITALRETAIL = 'DMS_DIGITALRETAIL',
    // Consumer resubmitted Credit Application from DE when it was originally submitted by Darwin
    DIGITALRETAILDE = 'DIGITALRETAILDE',
    ROUTEONE = 'ROUTEONE',
    ROUTEONEDE = 'ROUTEONEDE',
    DMS_ROUTEONE = 'DMS_ROUTEONE',
}
export enum FinanceType {
    None = 'None',
    Loan = 'Loan',
    Lease = 'Lease',
    Balloon = 'Balloon',
}

export const FinanceTypeNumericMap: Record<FinanceType, number> = {
    [FinanceType.None]: 0,
    [FinanceType.Loan]: 1,
    [FinanceType.Lease]: 2,
    [FinanceType.Balloon]: 3,
};
